import { useEffect, useState } from "react";
import { Upload, X, Check } from "lucide-react";
import { toast } from "sonner";
import api, { fileUrl, formatApiError } from "@/lib/api";

export default function MediaPicker({ open, onClose, onSelect }) {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);

  const load = () => api.get("/admin/media").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { if (open) load(); }, [open]);

  const upload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Uploaded");
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setUploading(false); e.target.value = ""; }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl w-full max-w-4xl max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-5 border-b">
          <h3 className="font-serif text-xl text-emerald-900">Media Library</h3>
          <div className="flex items-center gap-3">
            <label className="inline-flex items-center gap-2 rounded-lg bg-emerald-800 text-amber-50 px-4 py-2 text-sm font-semibold cursor-pointer hover:bg-emerald-900" data-testid="media-upload-btn">
              <Upload size={16} /> {uploading ? "Uploading…" : "Upload"}
              <input type="file" accept="image/*" className="hidden" onChange={upload} disabled={uploading} />
            </label>
            <button onClick={onClose}><X /></button>
          </div>
        </div>
        <div className="p-5 overflow-y-auto grid grid-cols-2 sm:grid-cols-4 gap-4">
          {items.length === 0 && <p className="col-span-full text-center text-stone-400 py-10">No media yet. Upload an image to get started.</p>}
          {items.map((m) => (
            <button key={m.id} onClick={() => { onSelect(fileUrl(m.storage_path), m); onClose(); }}
              className="group relative rounded-xl overflow-hidden border border-stone-200 hover:ring-2 ring-emerald-600 aspect-square">
              <img src={fileUrl(m.storage_path)} alt={m.alt || m.original_filename} className="w-full h-full object-cover" />
              <span className="absolute inset-0 bg-emerald-900/0 group-hover:bg-emerald-900/40 flex items-center justify-center transition-colors"><Check className="text-white opacity-0 group-hover:opacity-100" /></span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
